var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.07206 3.28285L5.51577 4.51077C6.00925 5.8736 7.08673 6.94661 8.45513 7.43804L9.68814 7.87993C9.79941 7.91985 9.79941 8.07678 9.68814 8.11671L8.45513 8.55859C7.08667 9.05004 6.00923 10.1231 5.51577 11.4859L5.07206 12.7138C5.03197 12.8246 4.87439 12.8246 4.8343 12.7138L4.39059 11.4859C3.89711 10.123 2.81963 9.05002 1.45122 8.55859L0.218221 8.11671C0.106947 8.07679 0.106947 7.91986 0.218221 7.87993L1.45122 7.43804C2.81968 6.94659 3.89713 5.87355 4.39059 4.51077L4.8343 3.28285C4.87438 3.17134 5.03197 3.17134 5.07206 3.28285Z",
    fill: "#FD853A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.619 0.332886L10.8443 0.954408C11.0945 1.64409 11.6399 2.18783 12.3331 2.437L12.9572 2.66138C13.0138 2.68203 13.0138 2.76118 12.9572 2.78114L12.3331 3.00552C11.6405 3.25469 11.0945 3.79775 10.8443 4.48812L10.619 5.10964C10.5983 5.16608 10.5188 5.16608 10.4988 5.10964L10.2735 4.48812C10.0233 3.79844 9.47798 3.25469 8.78476 3.00552L8.16067 2.78114C8.104 2.7605 8.104 2.68134 8.16067 2.66138L8.78476 2.437C9.47729 2.18783 10.0233 1.64477 10.2735 0.954408L10.4988 0.332886C10.5188 0.275757 10.599 0.275757 10.619 0.332886Z",
    fill: "#FD853A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.619 10.89L10.8443 11.5115C11.0945 12.2012 11.6399 12.7449 12.3331 12.9941L12.9572 13.2185C13.0138 13.2391 13.0138 13.3183 12.9572 13.3382L12.3331 13.5626C11.6405 13.8118 11.0945 14.3549 10.8443 15.0452L10.619 15.6667C10.5983 15.7232 10.5188 15.7232 10.4988 15.6667L10.2735 15.0452C10.0233 14.3555 9.47798 13.8118 8.78476 13.5626L8.16067 13.3382C8.104 13.3176 8.104 13.2384 8.16067 13.2185L8.78476 12.9941C9.47729 12.7449 10.0233 12.2019 10.2735 11.5115L10.4988 10.89C10.5188 10.8335 10.599 10.8335 10.619 10.89Z",
    fill: "#FD853A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/Stars.3e96c0d34c8493f72e5350516db9e315.svg";
export { ForwardRef as ReactComponent };